/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import Immutable from "seamless-immutable";
import {
  LOGIN_ACCOUNT_FAILURE,
  LOGIN_ACCOUNT_REQUEST,
  LOGIN_ACCOUNT_SUCCESS,
  LOGIN_WITH_FACEBOOK_FAILURE,
  LOGIN_WITH_FACEBOOK_REQUEST,
  LOGIN_WITH_FACEBOOK_SUCCESS,
  LOGOUT_ACCOUNT_REQUEST,
  LOGOUT_ACCOUNT_SUCCESS,
  SIGN_UP_ACCOUNT_FAILURE,
  SIGN_UP_ACCOUNT_REQUEST,
  SIGN_UP_ACCOUNT_SUCCESS,
  UPDATE_ACCESS_TOKEN,
  UPDATE_USER_NAME,
  CLEAR_USER_NAME,
  POST_RESET_PASSWORD_WITH_EMAIL_FAILURE,
  POST_RESET_PASSWORD_WITH_EMAIL_SUCCESS,
  POST_RESET_PASSWORD_WITH_EMAIL_REQUEST,
  POST_RESET_PASSWORD_WITH_PHONE_FAILURE,
  POST_RESET_PASSWORD_WITH_PHONE_SUCCESS,
  POST_RESET_PASSWORD_WITH_PHONE_REQUEST,
  POST_FORGET_PASSWORD_FAILURE,
  POST_FORGET_PASSWORD_SUCCESS,
  POST_FORGET_PASSWORD_REQUEST,
  SET_LOGIN_PROFILE_STATUS
} from "../actions/auth";
import AuthManager from "../utils/AuthManager";

const INITIAL_STATE = Immutable({
  rememberMe: true,
  mobileNumber: AuthManager.retrieveUserName(),
  token: AuthManager.retrieveToken(),
  auth: null,
  profileStatus: AuthManager.retrieveProfileStatus()
});

function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SIGN_UP_ACCOUNT_REQUEST:
      return state
        .merge({ isSignUpSuccess: false })
        .setIn(["auth", "signUp", "loading"], true);
    case SIGN_UP_ACCOUNT_SUCCESS:
      return state.setIn(["auth", "signUp", "loading"], false);
    case SIGN_UP_ACCOUNT_FAILURE:
      return state.setIn(["auth", "signUp", "loading"], false);
    case LOGIN_ACCOUNT_REQUEST:
      if (action.rememberMe) {
        return state
          .setIn(["auth", "login", "loading"], true)
          .setIn(["rememberMe"], true);
      }
      return state.setIn(["auth", "login", "loading"], true);
    case LOGIN_ACCOUNT_SUCCESS:
      return state.setIn(["auth", "login", "loading"], false);
    case LOGIN_ACCOUNT_FAILURE:
      return state.setIn(["auth", "login", "loading"], false);
    case LOGIN_WITH_FACEBOOK_REQUEST:
      return state.setIn(["auth", "login", "loading"], true);
    case LOGIN_WITH_FACEBOOK_SUCCESS:
      return state.setIn(["auth", "login", "loading"], false);
    case LOGIN_WITH_FACEBOOK_FAILURE:
      return state.setIn(["auth", "login", "loading"], false);
    case LOGOUT_ACCOUNT_REQUEST:
      return state.setIn(["logoutStatus"], false);
    case LOGOUT_ACCOUNT_SUCCESS:
      return state.setIn(["logoutStatus"], true).setIn(["token"], null);
    case UPDATE_ACCESS_TOKEN:
      return state.merge({ token: action.token });
    case UPDATE_USER_NAME:
      return state.merge({ mobileNumber: action.mobileNumber });
    case CLEAR_USER_NAME:
      return state.merge({ mobileNumber: null });
    case POST_FORGET_PASSWORD_REQUEST:
      return state
        .setIn(["auth", "forgotPassword", "loading"], true)
        .setIn(["auth", "forgotPassword", "status"], false);
    case POST_FORGET_PASSWORD_SUCCESS:
      return state
        .setIn(["auth", "forgotPassword", "loading"], false)
        .setIn(["auth", "forgotPassword", "status"], true)
        .setIn(["auth", "forgotPassword", "item"], action.data);
    case POST_FORGET_PASSWORD_FAILURE:
      return state
        .setIn(["auth", "forgotPassword", "loading"], false)
        .setIn(["auth", "forgotPassword", "status"], false);
    case POST_RESET_PASSWORD_WITH_PHONE_REQUEST:
      return state
        .setIn(["auth", "resetPasswordWithPhone", "loading"], true)
        .setIn(["auth", "resetPasswordWithPhone", "status"], false);
    case POST_RESET_PASSWORD_WITH_PHONE_SUCCESS:
      return state
        .setIn(["auth", "resetPasswordWithPhone", "loading"], false)
        .setIn(["auth", "resetPasswordWithPhone", "status"], true)
        .setIn(["auth", "resetPasswordWithPhone", "item"], action.data);
    case POST_RESET_PASSWORD_WITH_PHONE_FAILURE:
      return state
        .setIn(["auth", "resetPasswordWithPhone", "loading"], false)
        .setIn(["auth", "resetPasswordWithPhone", "status"], false);
    case POST_RESET_PASSWORD_WITH_EMAIL_REQUEST:
      return state
        .setIn(["auth", "resetPasswordWithEmail", "loading"], true)
        .setIn(["auth", "resetPasswordWithEmail", "status"], false);
    case POST_RESET_PASSWORD_WITH_EMAIL_SUCCESS:
      return state
        .setIn(["auth", "resetPasswordWithEmail", "loading"], false)
        .setIn(["auth", "resetPasswordWithEmail", "status"], true);
    case POST_RESET_PASSWORD_WITH_EMAIL_FAILURE:
      return state
        .setIn(["auth", "resetPasswordWithEmail", "loading"], false)
        .setIn(["auth", "resetPasswordWithEmail", "status"], false);
    case SET_LOGIN_PROFILE_STATUS:
      return state.setIn(["profileStatus"], action.status);
    default:
      return state;
  }
}

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js